import { FORMS_KEYS } from "helper/constant";
import React from "react";

const FormElement = ({ question, answer }) => {
  return (
    <div className="p-2 ">
      <div className="fs-16 demi-bold-text">{question}</div>
      <div>
        <i className="fas fa-arrow-right pr-1"></i>
        {answer ? (
          <>
            Yes <span className="form-label">&nbsp;&nbsp;+1</span>
          </>
        ) : (
          <span>No</span>
        )}
      </div>
    </div>
  );
};

const ACEQForm = props => {
  return (
    <div>
      <div className="fs-18 bold-text pb-2">ACE-Q</div>
      <FormElement
        question={FORMS_KEYS[17]["verbal_abuse_or_threat"]}
        answer={props?.data?.verbal_abuse_or_threat}
      />
      <FormElement
        question={FORMS_KEYS[17]["physical_abuse"]}
        answer={props?.data?.physical_abuse}
      />
      <FormElement
        question={FORMS_KEYS[17]["sexual_abuse"]}
        answer={props?.data?.sexual_abuse}
      />
      <FormElement
        question={FORMS_KEYS[17]["emotional_neglect"]}
        answer={props?.data?.emotional_neglect}
      />
      <FormElement
        question={FORMS_KEYS[17]["physical_neglect"]}
        answer={props?.data?.physical_neglect}
      />
      <FormElement
        question={FORMS_KEYS[17]["parents_separated_or_divorced"]}
        answer={props?.data?.parents_separated_or_divorced}
      />
      <FormElement
        question={FORMS_KEYS[17]["mother_abused"]}
        answer={props?.data?.mother_abused}
      />
      <FormElement
        question={FORMS_KEYS[17]["household_substance_abuse"]}
        answer={props?.data?.household_substance_abuse}
      />
      <FormElement
        question={FORMS_KEYS[17]["household_mental_illness"]}
        answer={props?.data?.household_mental_illness}
      />
      <FormElement
        question={FORMS_KEYS[17]["household_incarceration"]}
        answer={props?.data?.household_incarceration}
      />
      <br />
      <p className="fs-16 demi-bold-text display-info-class">
        ACE Score :{" "}
        <span className="fs-16 demi-bold-text form-label">
          {Boolean(props?.data?.verbal_abuse_or_threat) +
            Boolean(props?.data?.physical_abuse) +
            Boolean(props?.data?.sexual_abuse) +
            Boolean(props?.data?.emotional_neglect) +
            Boolean(props?.data?.physical_neglect) +
            Boolean(props?.data?.parents_separated_or_divorced) +
            Boolean(props?.data?.mother_abused) +
            Boolean(props?.data?.household_substance_abuse) +
            Boolean(props?.data?.household_mental_illness) +
            Boolean(props?.data?.household_incarceration)}
        </span>
      </p>
    </div>
  );
};

export default ACEQForm;
